export default {
  loaderHandler: (state) => state.loader,
  alertConfiguration: (state) => state.alert,
  snackbarMessage: (state) => state.snackbar,
  filtersApplied: (state) => state.filters,
  isLoading: (state) => state.loader,
  viewConfiguration: (state) => state.viewConfiguration,
  currency: (state) => state.currency,
  currencySuffix: (state) => state.currencySuffix
}
